import { styled } from '@mui/material/styles';
import { MenuItem } from '@mui/material';

export const MenuItemWrapper = styled(MenuItem)(({ theme }) => ({
  paddingTop: '4px',
  paddingBottom: '4px'
}));
